window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600
  }
});

// Registers each cart bundle item's remove button
document.body.addEventListener("click", async (event) => {
  if (!event.target.matches("a.cart__remove-bundle *")) return;
  const bundle_id = event.target.closest("a.cart__remove-bundle").getAttribute("data-bundle-id");

  if (bundle_id) {
    try {
      event.preventDefault();
      // Get current cart contents
      const cart = await (await fetch("/cart.js")).json();

      // Create data object for cart update AJAX call
      const data = {
        updates: cart.items.reduce((acc, item) => (item.properties?._bundleUid == bundle_id ? { ...acc, [item.key]: 0 } : acc), {})
      };

      // API call to update the cart contents and set the bundle item quantities to 0
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });

      response.ok && (window.location.href = "/cart");
    } catch (error) {
      console.error(error);
    }
  }
});

// if window location href includes '/tools/bundle-subscriptions' and 'subscriptionId='
// then get all '#bundleapp-subscriptions-root .addon-container .bundle-product-card button' and replace their inner text with 'pepo'
if (window.location.href.includes("/tools/bundle-subscriptions") && window.location.href.includes("subscriptionId=")) {
  // add a mutation observer on the body until '"#bundleapp-subscriptions-root .addon-container .bundle-product-card button"' exists
  const observer = new MutationObserver((mutations) => {
    if (document.querySelectorAll("#bundleapp-subscriptions-root .addon-container .bundle-product-card button").length) {
      document.querySelectorAll("#bundleapp-subscriptions-root .addon-container .bundle-product-card button").forEach((button) => {
        button.innerText = "Customize my order";
      });
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
